import { render, staticRenderFns } from "./Maquinas.vue?vue&type=template&id=e80f6d0c&"
import script from "./Maquinas.vue?vue&type=script&lang=js&"
export * from "./Maquinas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports